"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LEAD_SOURCES = void 0;
/* LEAD */
var LEAD_SOURCES = exports.LEAD_SOURCES = {
  BOOST_LANDING: "BOOST_LANDING",
  BOOST_POPUP: "BOOST_POPUP",
  BOOST_PRICING: "BOOST_PRICING",
  CARD_LANDING: "CARD_LANDING",
  PLATFORM_ONBOARDING: "PLATFORM_ONBOARDING",
  KOSMOFI_LANDING: "KOSMOFI_LANDING"
};